import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import undoicon from "../assets/icons/icon-undo.svg";
import redoicon from "../assets/icons/icon-redo.svg";
import zoominicon from "../assets/icons/icon-zoomin.svg";
import minusicon from "../assets/icons/icon-minus.svg";
import { setActiveTab } from "../Store/reducers/activeTabSlice";
import { undo, redo } from "../Store/reducers/fabriccontrolsSlice.js";
import { useZoomControls } from "./customHooks/useZoomControls.jsx";
import {
  startPanning,
  movePanning,
  stopPanning,
} from "./pixiComponents/panningUtils.jsx";
import {
  undoAndReload,
  redoAndReload,
} from "../Store/reducers/fabriccontrolsSlice.js";

const Controls = () => {
  const [activeButton, setActiveButton] = useState("previewMockup");
  const dispatch = useDispatch();
  const fabricCanvas = useSelector((state) => state.fabricCanvas.fabricCanvas);
  const zoom = useSelector((state) => state.canvasesstate.zoom);
  const pixiCanvas = useSelector((state) => state.canvas.app);
  const activeTab = useSelector((state) => state.activeTab.activeTab);
  const { isCanvasLoaded, isTexturesLoaded } = useSelector(
    (state) => state.wait
  );

  const isEditMockupDisabled =   activeTab === "previewMockup" && !isCanvasLoaded;
  console.log("disabled", isEditMockupDisabled);

  useEffect(() => {
    setActiveButton(activeTab);
  }, [activeTab]);

  const handleButtonClick = (tab) => {
    setActiveButton(tab);
    dispatch(setActiveTab(tab));
  };

  const { zoomIn, zoomOut } = useZoomControls({
    dispatch,
    zoom,
    fabricCanvas,
    activeTab,
    pixiCanvas,
  });

  useEffect(() => {
    if (!pixiCanvas || !pixiCanvas.view || activeTab !== "previewMockup")
      return;

    const view = pixiCanvas.view;
    const cameraContainer = pixiCanvas.cameraContainer;
    let panningState = { isPanning: false };

    const onPointerDown = (event) => {
      panningState = startPanning(event, view, cameraContainer, zoom);
      if (panningState.isPanning) view.style.cursor = "grabbing";
    };

    const onPointerMove = (event) => {
      panningState = movePanning(
        event,
        panningState,
        view,
        cameraContainer,
        pixiCanvas
      );
    };

    const onPointerUp = () => {
      panningState = stopPanning(panningState, view);
    };

    view.addEventListener("pointerdown", onPointerDown);
    view.addEventListener("pointermove", onPointerMove);
    view.addEventListener("pointerup", onPointerUp);
    view.addEventListener("pointerupoutside", onPointerUp);

    return () => {
      view.removeEventListener("pointerdown", onPointerDown);
      view.removeEventListener("pointermove", onPointerMove);
      view.removeEventListener("pointerup", onPointerUp);
      view.removeEventListener("pointerupoutside", onPointerUp);
    };
  }, [pixiCanvas, zoom, activeTab]);

  return (
    <div className="flex justify-center items-center mt-[10px] mb-[10px]">
      <div className="flex items-center justify-center gap-[12px]">
        {/* Undo / Redo Controls */}
        <div className="bg-white flex flex-row justify-center items-center rounded space-x-4 mt-4">
          <button
            className="px-2 py-1 hover:bg-gray-200"
            onClick={() => dispatch(undoAndReload(`${activeTab}CanvasState`))}
          >
            <img src={undoicon} alt="undo Icon" className="w-[15px] h-[15px]" />
          </button>
          <button
            className="px-2 py-1 hover:bg-gray-200"
            onClick={() => dispatch(redoAndReload(`${activeTab}CanvasState`))}
          >
            <img src={redoicon} alt="redo Icon" className="w-[15px] h-[15px]" />
          </button>
        </div>

        {/* Zoom Controls */}
        <div className="bg-white flex flex-row justify-center items-center rounded space-x-4 mt-4 mr-40">
          <button className="px-2 text-gray-700" onClick={zoomOut}>
            <img
              src={minusicon}
              alt="minus Icon"
              className="w-[8px] h-[12px]"
            />
          </button>
          <input
            type="text"
            className="w-[42px] h-[15px] font-montserrat leading-[11px] bg-[#ECEBEB] text-center text-[13px] border-none focus:outline-none"
            value={`${(zoom * 100).toFixed(0)}%`}
            readOnly
          />
          <button className="text-gray-700 px-2 py-1" onClick={zoomIn}>
            <img
              src={zoominicon}
              alt="zoomin Icon"
              className="w-[15px] h-[15px]"
            />
          </button>
        </div>

        {/* Action Buttons */}
        <div className="flex items-center justify-center space-x-2 mt-4">
          <button
            className={`${
              activeButton === "previewMockup"
                ? "bg-sky-500 text-white"
                : "bg-white text-black"
            } whitespace-nowrap px-2 py-1 font-montserrat text-[12px] font-semibold rounded`}
            onClick={() => handleButtonClick("previewMockup")}
          >
            Preview on Mockup
          </button>
          <button
            className={`${
              activeButton === "editMockup"
                ? "bg-sky-500 text-white"
                : "bg-white text-black"
            } whitespace-nowrap px-2 py-1 font-montserrat text-[12px] font-semibold rounded
  ${isEditMockupDisabled ? "opacity-50 cursor-not-allowed" : ""}`}
            onClick={() => handleButtonClick("editMockup")}
            disabled={isEditMockupDisabled}
          >
            Style Mockup
          </button>
          <button
            className={`${
              activeButton === "editSVG"
                ? "bg-sky-500 text-white"
                : "bg-white text-black"
            } whitespace-nowrap px-2 py-1 font-montserrat text-[12px] font-semibold rounded`}
            onClick={() => handleButtonClick("editSVG")}
          >
            Edit SVG
          </button>
        </div>
      </div>
    </div>
  );
};

export default Controls;
